import React from "react";
import { FiThumbsDown, FiThumbsUp, FiCheck, FiStar } from "react-icons/fi";
import Navbar from "../../../@shared/navigations/default";
import { Options } from "../options";

const AccountRequestsPage = () => (
  <>
   <Navbar />
    <div className="container3">
      <div className="">

        <div>
          <Requests />
        </div>

        <div>
        <Options title="Favorites" path='/account/requests'  /> <br />

        </div>

      </div>
    </div>

  </>
)

export default AccountRequestsPage
  


export const Requests = () => {
    React.useEffect(()=>{  },[])
    let requests = requestList;
    return ( 
        <div className="requests-component list_view">
              <ul>
                {
                    requests.length>0 && requests.map((item,i)=>{
                        return <ProjectItem key={`requests-${i}`} item={item} />
                    })
                }
                {requests.length<=0 && (
                    <EmptyWrapper />
                )}
              
               {
                   true && requestList.map((item,i)=>(
                     <RequestItem key={'requests'+i} item={item} />
                   ))
               }
            </ul>
        </div>
    )
}

export const EmptyWrapper = ({title=''}) => (
    <div className="empty-wrapper">
        <div>
            <img src="/assets/images/assets/empty.svg" alt="" />
            <h3>{title||'Blank!'}</h3>
        </div>
    </div>
)

export const ProjectItem = ({ item }) => {

    return (
        <li >
            <div className="project flex">
                <div className="list">
                    <div className="owner">
                        <a href={`/users/${item.user._id}`} target="_blank" rel="noreferrer" className="flex-column" >
                            <div className="name">{item.user.name}</div>

                            {item?.avatar && <img src={`/assets/images/faces/${item.avatar}.png`} draggable="false" alt="" />}
                            {!item?.avatar && item.user.avatar && <img src={`${item.user.avatar}`} alt={item.user.name} draggable="false" />}
                            {!item?.avatar && !item.user.avatar && <img src="/assets/images/faces/default.svg" alt={item.user.name} draggable="false" />}
                            <p className="date">{item.user.date}</p>
                        </a>
                        {true && (
                            <Thumbs
                                id={0}
                                likes={item.user.like}
                                dislikes={item.user.dislike}
                            />
                        )}
                    </div>
                    <div className="detail">
                        <div className="info">
                            <a href={`/projects/single`} className="flex"> {/** ${item.id} **/}
                                <div className="title">{item.title} {item.privacy && <div className="private">Private</div>} </div>
                            </a> 
                            <div className="stars">
                                {Array.from(Array(item.star)).map((star)=><FiStar />)}
                                <p className="reviews">{item.reviews} Reviews</p>
                            </div>
                            <ul>
                                {item.sector?.length > 0 && <li><p>sector: </p><b>{item.sector[0]?.title}</b></li>}
                                {item.job?.length > 0 && <li><p>type: </p><b>{item?.job[0]?.title}</b></li>}
                                {item.era?.length > 0 && <li><p>era: </p><b>{item.era?.length > 0 && item.era[0]?.title}</b></li>}
                            </ul>
                        </div>
                        
                    </div>
                </div>
                <div className="cover">
                    {item?.img && <img src={`/assets/images/projects/${item.img}.jpg`} alt="" />}
                    {item.images?.length > 0 && <img src={`/${item.images?.find((i) => i.default===true)?.path || item.images[0]?.path}`} draggable="false" alt={item.title} />}
                </div>
            </div>
        </li>
    )
}


export const Thumbs = ({likes, dislikes}) => {
    const [like] = React.useState(true)
    const [dislike] = React.useState(false);
    return (
        <div className="thumbs">
            <div><FiThumbsUp className={`${like ? 'up': ''}`} /> {likes}</div>
            <div><FiThumbsDown className={`${dislike ? 'down': ''}`} /> {dislikes}</div>
        </div>
    )
}

export const RequestItem = ({item}) => {

    return (
        <li>
            <div className="owner">
                <p>KURUCU</p>
                <div className="name">{item?.user.name}</div>
                {item?.avatar && <img src={`/assets/images/faces/${item?.avatar}.png`} alt={item?.user.name} draggable="false"  />}
                {!item?.avatar && <img src="/assets/images/faces/default.svg"  alt={item?.user.name} draggable="false"  /> }
                <p className="date">{item?.user.date}</p>
                <div className="thumbs">
                    <div><FiThumbsUp className="up" /> {item?.user.like}</div>
                    <div><FiThumbsDown className="down" /> {item?.user.dislike}</div>
                </div>
            </div>
            <div className="detail">
                <p className="title">Mentorluk için uzman olduğum alanlar</p>
                <ul className="flex-start">
                    {item?.job?.map((job,i)=>(
                       <li key={'job'+i} className="flex-start">
                           <div className="checkbox"><FiCheck /> </div>
                           {job?.title}
                       </li>
                    ))}                        
                </ul>
                <p className="title">Mentorluk hizmeti verebileceğim çalışma şekillerim</p>
                <ul className="flex-start">
                    {item?.workstyle?.map((workstyle,i)=>( 
                        <li key={'work'+i} className="flex-start">
                            <div className="checkbox"><FiCheck /> </div>
                            {workstyle}
                        </li>

                    ))}
                </ul>
                <p className="title">Mentorluk desteğine uygun olduğum şehirler</p>
                <ul className="flex-start">
                    {item?.era?.map((era,i)=>(
                        <li key={'era'+i} className="flex-start">
                            <div className="checkbox"><FiCheck /> </div>
                            {era?.title}
                        </li>
                    ))}
                </ul>


                <div className="flex-end">
                    <div className="button blue">Preview</div>
                    {!item?.request &&  <div className="button red">Reject</div>}
                    {item?.request && <div className="button green">Accept</div>}
                </div>
            </div>
        </li>
    )
}

export const requestList = [
    {title:'Mollitia ducimus laudantium id eius', sector:[{title:'Aerospace'}], job:[{title:'Aircraft design & mechanics'}], era:[{title:'Egypt'}], category:'', avatar:1, img:19, reviews:3673, star:5, privacy:true, user:{name:'Author',  date:'07/10/2025'},  },
    {title:'Lorem ipsum dolor sit amet consectetur adipisicing elit.', sector:[{title:'Agriculture'}], job:[{title:'Agronomist / Food inspector'}], era:[{title:'France'}], category:'', avatar:5, img:20, reviews:93, star:4, privacy:false, user:{name:'Author',  date:'07/10/2025'},  },
    {title:'Lorem ipsum dolor sit amet consectetur adipisicing elit.', sector:[{title:'Energy'}], job:[{title:'Electricity'}], era:[{title:'Washington'}], category:'', avatar:8, img:21, reviews:57, star:3, privacy:true, user:{name:'Author',  date:'07/10/2025'},  },

    { 
        title:'REQ',
      job:['Electronics'],
      workstyle:['Fulltime'], 
      era:['All'], 
      user:{
        name:'Author',  
        date:'07/10/2025', 
        like:287, 
        dislike:37
    }, 
      request:true  
    },
    {job:['Electronics'], workstyle:['Fulltime'], era:['All'], user:{name:'Author',  date:'07/10/2025', }, request:true  },
    {job:['Electronics'], workstyle:['Fulltime'], era:['All'], user:{name:'Author',  date:'07/10/2025', like:287, dislike:37}, request:false  },
  ]; 
